import '@angular/localize/init';
import { loadTranslations } from '@angular/localize';
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { AppConfig } from "./app/shared/config";

if (environment.production) {
  enableProdMode();
}
let url = AppConfig.getConfigUrl();
/*
if (location.hostname.includes("dev2.cdpfnol.nprd.aig.com")) {
  url = "assets/config/config.json";
} else if(location.hostname.includes("qa2.cdpfnol.nprd.aig.com")) {
 url = "assets/config/config-qa.json";
} else{
  url = "assets/config/config.json";
}
*/

// Generated by AIG Copilot - start
// Self-executing async function to handle initialization
(async () => {
  try {
    // Get country and language from URL path
    const pathParts = window.location.pathname.split('/');
    const country = pathParts[2];
    const language = pathParts[3];
    
    // Load translations if language is present
    if (language) {
      try {
        const translationResponse = await fetch(`/assets/i18n/${country}/${language}.json`);
        const translationData = await translationResponse.json();
        if (translationData.translations) {
          // @ts-ignore
          loadTranslations(translationData.translations);
        }
      } catch (err) {
        console.log('translation files are not present', err);
      }
    }

    // Load configuration
    const configResponse = await fetch(url);
    const configJson = await configResponse.json();
    AppConfig.setEnvConfig(configJson);

    if (AppConfig.isSplunkRumEnabled) {
      AppConfig.loadSplunkRumScripts();
    }

    // Bootstrap the Angular application
    await platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));

  } catch (err) {
    console.log("error during initialization: ", err);
  }
})();
// Generated by AIG Copilot - end
